import { Grid } from '@mui/material'

import { containerSx } from './styles'

import { ContactForm } from './components/ContactForm'
import { LetsTalk } from './components/LetsTalk'

interface IContactUs {
  invert?: boolean
}

const ContactUs = ({ invert }: IContactUs) => (
  <Grid data-testid="contact-us-section" container sx={containerSx}>
    <LetsTalk
      containerSxOverride={{
        order: { lg: invert ? 2 : 1, xs: invert ? 1 : 2 },
      }}
    />
    <ContactForm
      containerOverrideSx={{
        order: { lg: invert ? 1 : 2, xs: invert ? 2 : 1 },
      }}
    />
  </Grid>
)

export { ContactUs }
